<template>
    <base-modal
        id="app-dialog"
        v-model="visible"
        variant="centered"
        modal-class="base-dialog"
        :body-class="{ 'is-centered': options.centerText }"
        :title="options.title || ''"
        :hide-header="!options.title && !options.icon"
        :hide-close="true"
        :hide-cancel="isAlert"
        :static-backdrop="options.blocking"
        :ok-text="okText"
        :cancel-text="options.cancelText"
        :ok-variant="options.danger ? 'danger' : 'primary'"
        @ok="confirm()"
        @hidden="settle()"
    >
        <template v-if="options.icon === 'warning'" #header>
            <div class="base-modal-heading">
                <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
                    <div class="swal2-icon-content">!</div>
                </div>
                <h3 v-if="options.title" id="app-dialog-title" class="modal-title">{{ options.title }}</h3>
            </div>
        </template>

        <img v-if="options.image" class="base-dialog-image" :src="options.image" alt="">
        <p v-if="options.subject" class="base-dialog-subject">{{ options.subject }}</p>
        <div v-if="options.html" class="base-dialog-text" v-html="options.html"></div>
        <p v-else-if="options.text" class="base-dialog-text" :class="{ 'is-text-pill': options.isTextPill }">{{ options.text }}</p>
    </base-modal>
</template>

<script>
import BaseModal from '@/core/components/BaseModal.vue';
import { dialogState } from '@/plugins/dialog';

export default {
    name:       'dialog-host',
    components: { BaseModal },

    data () {
        return {
            visible:   false,
            confirmed: false
        };
    },

    computed: {
        current () {
            return dialogState.queue[0] || null;
        },

        options () {
            return this.current ? this.current.options : {};
        },

        isAlert () {
            return this.current !== null && this.current.type === 'alert';
        },

        okText () {
            if (this.isAlert) {
                return this.options.okText || this.$t('ok');
            }

            return this.options.confirmText || this.$t('confirm');
        }
    },

    watch: {
        current: {
            immediate: true,
            handler (entry) {
                if (entry && !this.visible) {
                    this.$nextTick(() => {
                        this.visible = true;
                    });
                }
            }
        }
    },

    methods: {
        confirm () {
            this.confirmed = true;
            this.visible   = false;
        },

        async settle () {
            const entry     = dialogState.queue.shift();
            const confirmed = this.confirmed;

            this.confirmed = false;

            if (!confirmed || !entry.options.onConfirm) {
                entry.resolve(confirmed);
                return;
            }

            try {
                await entry.options.onConfirm();
                entry.resolve(true);
            } catch (error) {
                entry.reject(error);
            }
        }
    }
};
</script>
